import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space2, space6 } = theme();

  return StyleSheet.create({
    questionGroup: {
      paddingBottom: space6,
    },
    title: {
      marginBottom: space2,
    },
  });
};

export { style };
